<template>
  <v-row class="base-layout no-gutters">
    <StHeader @side-icon-clicked="handleToggleDrawer">
      <template #center>
        <StCompanySelector
          class="mx-6"
          :companies="companies"
          :company-id="companyId"
          @updateCompany="updateCompany"
        />
      </template>

      <template #right>
        <div class="st-header-right">
          <a
            href="https://suporte.stilingue.com.br/hc/pt-br"
            target="_blank"
            rel="noopener noreferrer"
            class="st-header-right__btn-help-center"
          >
            <DsIcon
              name="faq"
              size="small"
            />
          </a>

          <StUserMenu
            :user="user"
            :greeting="$t('Layout.greeting')"
            :logout-label="$t('Layout.logout')"
            @logout-item-clicked="logout"
          />
        </div>
      </template>
    </StHeader>

    <v-main class="content-white">
      <v-row class="no-gutters fill-height">
        <LayoutContent />

        <StSystemNavigationDrawer
          :drawer="drawer"
          :items="itemsInDrawer"
          :active-url="itemActive"
          @navigate="goTo"
        />
      </v-row>
    </v-main>
  </v-row>
</template>

<script>
import StHeader from '@stilingue/st-header';
import StUserMenu from '@stilingue/st-user-menu';
import StSystemNavigationDrawer from '@stilingue/st-system-navigation-drawer';
import StCompanySelector from '@stilingue/st-company-selector';

import { DsIcon } from '@ds/icons';
import LayoutContent from '@/layouts/LayoutContent';
import { canUserAccessSetupModule } from '@/utils';

export default {
  name: 'Layout',
  components: {
    StSystemNavigationDrawer,
    StHeader,
    StCompanySelector,
    StUserMenu,
    LayoutContent,
    DsIcon,
  },
  data() {
    return {
      itemActive: 'https://benchmarks.stilingue.com.br',
    };
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    drawer() {
      return this.$store.state.misc.drawer;
    },
    companies() {
      return this.$store.state.company.companies;
    },
    activeCompany() {
      return this.$store.state.company.activeCompany;
    },
    companyId() {
      return String(this.activeCompany?.id);
    },
    itemsInDrawer() {
      return [
        {
          name: this.$t('StSystemNavigationDrawer.warroom'),
          link: 'https://warroom.stilingue.com.br',
        },
        {
          name: this.$t('StSystemNavigationDrawer.smartcare'),
          link: 'https://smartcare.stilingue.com.br/conversas',
        },
        {
          name: this.$t('StSystemNavigationDrawer.performance'),
          link: 'https://warroom.stilingue.com.br/metricas-proprietarias',
        },
        ...this.privateRoutes,
      ];
    },
    privateRoutes() {
      return canUserAccessSetupModule(this.user)
        ? [
          {
            name: 'Consultar Benchmarks',
            local: true,
            link: '/setup/management-benchmarks',
          },
          {
            name: 'Novo Benchmarks',
            local: true,
            link: '/setup/new-benchmarks',
          },
          {
            name: 'Editar Benchmarks',
            local: true,
            link: '/setup/edit-benchmarks',
          },
        ] : [];
    },
  },
  methods: {
    handleToggleDrawer() {
      this.$store.commit('misc/TOGGLE_DRAWER');
    },
    logout() {
      const url = `${process.env.VUE_APP_STILINGUE_LOGIN_SERVICE}logout?np_red=${window.location.origin}`;

      window.location.href = url;
    },
    goTo(item) {
      if (item.local) {
        this.handleToggleDrawer();
        return this.$router.push({
          path: item.link,
        });
      }

      const win = window.open(item.link, '_blank');
      win.focus();
    },
    async updateCompany(company) {
      this.$store.dispatch('company/addActiveCompany', company);

      await this.$store.dispatch('benchmarks/startBenchmarks', {
        activeCompany: company,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.base-layout {
  background: white;
}

.st-header-right {
  display: flex;
  align-items: center;
  justify-content: center;

  &__btn-help-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 56px;
    width: 56px;
    margin-right: var(--ds-spacing-stack-xs);
    transition: all 0.2s ease-in-out;
    background-color: var(--ds-color-reverse);

    &:hover {
      background: var(--ds-color-text-highlight);
    }

    i {
      background-color: var(--ds-color-white-text);
    }
  }
}

::v-deep {
  .v-toolbar__content {
    padding-right: var(--ds-spacing-stack-xs);
  }
}
</style>
